const en = {
  translation: {
    introduce: 'Boilerplate Frontend',
    viewExample: 'View Example'
  }
};

export default en;
